<template>
  <v-container fluid class="px-0">
    <v-card outlined class="my-0">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Įgaliojimų registro objekto identifikavimo kodas (žurnalo numeris)"
                  v-model="mainData['id-search-custom']"
                  hide-details
                  :maxlength="12"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <el-date-picker
                  label="Objekto išregistravimo / pranešimo atmetimo data nuo"
                  v-model="mainData['deregistration_date_from']"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <el-date-picker
                  label="Objekto išregistravimo / pranešimo atmetimo data iki"
                  v-model="mainData['deregistration_date_to']"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="beforeSearch()"
                />
                <el-button
                  class="mr-1"
                  title="Naujas naikinimo aktas"
                  :loading="loading"
                  color="primary"
                  icon="pirmyn"
                  @click.native.stop="newDestructionAct()"
                  v-if="isActiveNewActButton"
                />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Enums from '@/enums'

export default {
  name: 'AdminDestroyedObjectSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    enumsClassifiers: [],
    isActiveNewActButton: false,
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getSearchParams()
  },
  methods: {
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getSearchParams() {
      this.enumsClassifiers = Enums
      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData(button) {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })
      searchData.btn = button
      this.$emit('search', searchData)
      if (button) {
        this.isActiveNewActButton = true
      }
    },
    newDestructionAct() {
      this.loading = true
      let formData = {
        code: this.mainData['id-search-custom'],
        deregistration_date_from: this.mainData['deregistration_date_from'],
        deregistration_date_to: this.mainData['deregistration_date_to'],
      }
      this.$axios
        .post(`destruction-acts`, formData)
        .then(() => {
          this.$router.push({
            name: 'adminDataDestructionActs',
          })
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR_TEXT', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearData() {
      this.mainData = { isExpanded: true, clear: true }
      this.$nextTick(() => {
        this.mainData = { isExpanded: true }
        this.searchData(true)
      })
    },
    submit() {
      this.beforeSearch()
    },
    beforeSearch() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.searchData(true)
        }
      })
    },
  },
}
</script>
